import tw from 'twin.macro';

import Content from '@components/Content';

export const Wrapper = tw.div`flex flex-col justify-between text-white mt-24`;
export const ColumnHeading = tw.h3`font-sans text-xl`;
export const FooterContent = tw(Content)`my-12`;
